/* eslint-disable no-nested-ternary */
import React, { useContext, useState as classicUseState } from 'react';
import { useMutation } from 'react-query';
import {
  createProduct,
  getProducts,
  getProductsAutocomplete,
} from '@services/queries/products';
import { IPaginationResult } from '@models/Equipment.model';
import { IProduct } from '@models/Product.model';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';
import {
  createManufacturer,
  getManufacturersAutocomplete,
  indexManufacturersPagination,
} from '@services/queries/manufacturers';
import { SearchBarAutocomplete } from '@components/SearchBars';
import { ListEquipmentsWithMatch } from '@pages/Products/components/AddEquipmentModal/components/SelectBody/components/ListEquipmentsWithMatch/ListEquipmentsWithMatch';
import Manufacturer, { IManufacturer } from '@models/Manufacturer.model';
import { ListManufacturersWithMatch } from '@pages/Products/components/AddEquipmentModal/components/SelectBody/components/ListManufacturersWithMatch/ListManufacturersWithMatch';
import { DeleteDialog } from '@components';
import { useState } from '@hookstate/core';

import ReactTooltip from 'react-tooltip';
import { getLastWord } from '@utils/getLastWord/getLastWord';
import { IAutoComplete } from '@store/redux/features/search/searchSlice';
import {
  manualAddSearchManufacturer,
  manualAddSearchProduct,
  manualAddSkipProduct,
} from '@services/mixpanel/trackers/ManualAdd';

import { NavigationContext } from '@layout/navigation/navigation';
import {
  Cancel,
  BodyFind,
  CenterText,
  WarningText,
  GlobalHeader,
  GlobalInputContainer,
  InputDiv,
  FindButton,
  Description,
  RowDiv,
  BoldText,
  Buttons,
  Skip,
  // SkipButton,
  // Tooltip,
} from './FindBody.styles';

const LIMIT = 200;

interface OwnProps {
  nextBody: () => void;
  updateDataSelected: (products?: ProductRequest[]) => void;
  loadingSearch: boolean;
  setLoadingSearch: (input: boolean) => void;
  data: IPaginationResult<IProduct> | undefined;
  setData: (input: IPaginationResult<IProduct> | undefined) => void;
  manufacturerArray: IPaginationResult<IManufacturer> | undefined;
  setManufacturerArray: (
    input: IPaginationResult<IManufacturer> | undefined,
  ) => void;
  page: number;
  setPage: (input: number) => void;
  setTextManufacturer: (input: string) => void;
  textManufacturer: string;
  setModelName: (input: string) => void;
  modelName: string;
  setModelNumber: (input: string) => void;
  modelNumber: string;
  setManufacturer: (input: IManufacturer | undefined) => void;
  manufacturer: IManufacturer | undefined;
}

export const FindBody = ({
  nextBody,
  updateDataSelected,
  loadingSearch,
  setLoadingSearch,
  data,
  setData,
  manufacturerArray,
  setManufacturerArray,
  page,
  setPage,
  setTextManufacturer,
  textManufacturer,
  setModelName,
  modelName,
  setModelNumber,
  modelNumber,
  setManufacturer,
  manufacturer,
}: OwnProps) => {
  const inputManufacturerRef = React.useRef<HTMLInputElement>(null);
  const inputProductRef = React.useRef<HTMLInputElement>(null);
  const [autocompleteManufacturerOptions, setAutocompleteManufacturerOptions] =
    classicUseState<IAutoComplete[]>([]);
  const [option, setOption] = classicUseState(-1);
  const [autocompleteProductOptions, setAutocompleteProductOptions] =
    classicUseState<IAutoComplete[]>([]);

  const { studioName } = useContext(NavigationContext);

  const handleProductFocus = () => {
    if (inputProductRef && inputProductRef.current) {
      inputProductRef.current.focus();
    }
  };
  const handleManufacturerFocus = () => {
    if (inputManufacturerRef && inputManufacturerRef.current) {
      inputManufacturerRef.current.focus();
    }
  };

  const openAlertDialog = useState(false);
  const getProductsWithSearch = useMutation(getProducts, {
    onSuccess: newData => {
      setPage(newData.currentPage);
      setAutocompleteProductOptions([]);
      setLoadingSearch(false);
      if (data && newData.currentPage > 1) {
        const resultsContacted = data.results.concat(newData.results);
        setData({
          total: newData.total,
          currentPage: newData.currentPage,
          totalPages: newData.totalPages,
          hasMore: newData.hasMore,
          results: resultsContacted,
        });
      } else
        setData({
          total: newData.total,
          currentPage: newData.currentPage,
          totalPages: newData.totalPages,
          hasMore: newData.hasMore,
          results: newData.results,
        });

      manualAddSearchProduct(studioName, modelName, newData.total > 0);
    },
    onError: () => {
      setLoadingSearch(false);
    },
  });
  const mutationCreateProduct = useMutation(createProduct, {
    onSuccess: product => {
      if (updateDataSelected)
        updateDataSelected([
          {
            product,
            quantity: 1,
            id: `${manufacturer?.id}-${product.id}-${modelName}`,
          },
        ]);
      openAlertDialog.set(false);
      nextBody();
    },
    onError: () => {
      //  toast.error('Updated failed!!');
    },
  });
  const mutationGetManufacturersNames = useMutation(
    indexManufacturersPagination,
    {
      onSuccess: result => {
        setPage(result.currentPage);
        setAutocompleteManufacturerOptions([]);
        setLoadingSearch(false);
        if (manufacturerArray && result.currentPage > 1) {
          const resultsContacted = manufacturerArray.results.concat(
            result.results,
          );
          setManufacturerArray({
            total: result.total,
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            hasMore: result.hasMore,
            results: resultsContacted,
          });
        } else {
          setManufacturerArray({
            total: result.total,
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            hasMore: result.hasMore,
            results: result.results,
          });

          manualAddSearchManufacturer(
            studioName,
            textManufacturer,
            result.total > 0,
          );
        }
      },
    },
  );
  const mutationGetManufactorAutocomplete = useMutation(
    getManufacturersAutocomplete,
    {
      onSuccess: result => {
        setAutocompleteManufacturerOptions(
          result.slice(0, 4).map(item => {
            return { labelOne: item.name, id: item.id };
          }),
        );
      },
    },
  );
  const mutationGetProductAutocomplete = useMutation(getProductsAutocomplete, {
    onSuccess: result => {
      setAutocompleteProductOptions(
        result.slice(0, 4).map(item => {
          return {
            labelOne:
              item.model && item.model.toLowerCase().includes(modelName)
                ? item.model
                : item.name,
            id: item.id,
          };
        }),
      );
    },
  });
  const mutationCreateManufacturer = useMutation(createManufacturer, {
    onSuccess: newManufacturer => {
      setManufacturer(newManufacturer);
      openAlertDialog.set(false);
      setLoadingSearch(false);
      setManufacturerArray(undefined);
      mutationCreateProduct.mutate({
        data: {
          name: modelName.length > 0 ? modelName : undefined,
          model: modelNumber.length > 0 ? modelNumber : undefined,
          description: undefined,
          manufacturerId:
            newManufacturer.id.length === 0 ? undefined : newManufacturer.id,
        },
      });
    },
    onError: () => {
      //  toast.error('Updated failed!');
    },
  });
  const startProductSearch = (search?: string) => {
    setLoadingSearch(true);
    setAutocompleteProductOptions([]);
    getProductsWithSearch.mutate({
      pagination: {
        page: 1,
        limit: LIMIT,
        search: undefined,
      },
      filter: {
        manufactorNames:
          manufacturer && manufacturer.id.length > 0
            ? [manufacturer.id]
            : undefined,
        modelName: search || modelName,
      },
    });
  };
  const startManufacturerSearch = (search?: string) => {
    setLoadingSearch(true);
    setAutocompleteManufacturerOptions([]);
    mutationGetManufacturersNames.mutate({
      pagination: {
        page: 1,
        limit: LIMIT,
        search: search || textManufacturer,
      },
      filter: undefined,
    });
  };

  const searchProductFunc = (input: string) => {
    setModelName(input);
    setOption(-1);
    if (
      getLastWord(input).length >= 2 &&
      input.charAt(input.length - 1) !== ' '
    ) {
      mutationGetProductAutocomplete.mutate({
        search: getLastWord(input),
        manufacturerId: manufacturer?.id,
      });
    } else setAutocompleteProductOptions([]);
  };
  const searchManufacturerFunc = (input: string) => {
    setOption(-1);
    setTextManufacturer(input);
    if (
      getLastWord(input).length >= 2 &&
      input.charAt(input.length - 1) !== ' '
    ) {
      mutationGetManufactorAutocomplete.mutate(getLastWord(input));
    } else setAutocompleteManufacturerOptions([]);
  };
  const loadMoreProducts = (input?: string) => {
    if (data?.hasMore)
      getProductsWithSearch.mutate({
        pagination: {
          page: page + 1,
          limit: 20,
          search: input === undefined ? modelNumber : input,
        },
        filter: {
          manufactorNames: manufacturer?.name ? [manufacturer.id] : undefined,
          modelNames: [modelName],
        },
      });
  };
  const loadMoreManufactures = () => {
    if (manufacturerArray?.hasMore)
      mutationGetManufacturersNames.mutate({
        pagination: {
          page: page + 1,
          limit: 20,
          search: textManufacturer,
        },
        filter: undefined,
      });
  };
  return (
    <BodyFind>
      <CenterText>
        To unlock the potential of BeamON, you must match it to a manufacturer
        and a model we’ve collected data for. This is how we can give you
        Manuals, Documents, Notifications such as firmware updates, and much
        more!
      </CenterText>
      <GlobalInputContainer>
        <InputDiv className="firstItem">
          <GlobalHeader>Manufacturer</GlobalHeader>
          <SearchBarAutocomplete
            inputRef={inputManufacturerRef}
            showOptions={autocompleteManufacturerOptions}
            setShowOptions={setAutocompleteManufacturerOptions}
            searchText={textManufacturer}
            isDisabled={manufacturer !== undefined}
            placeholder=""
            loadingSearch={loadingSearch}
            showErasedSearch={loadingSearch}
            searchOnChange={searchManufacturerFunc}
            closeIconOnClick={() => {
              setTextManufacturer('');
              setManufacturer(undefined);
              setData(undefined);
              setManufacturerArray(undefined);
              setModelNumber('');
              setModelName('');
            }}
            onClickFilter={item => {
              setTextManufacturer(item.labelOne);
              setLoadingSearch(true);
              setOption(-1);
              setAutocompleteManufacturerOptions([]);
              startManufacturerSearch(item.labelOne);
            }}
            option={option}
            setOption={setOption}
            autoFocus
          />
        </InputDiv>
        {!manufacturer && (
          <FindButton
            onClick={() => {
              startManufacturerSearch();
              setLoadingSearch(true);
            }}
          >
            Find!
          </FindButton>
        )}

        <InputDiv isDisabled={manufacturer === undefined}>
          <GlobalHeader>Product Name or Model #</GlobalHeader>

          <SearchBarAutocomplete
            inputRef={inputProductRef}
            showOptions={autocompleteProductOptions}
            setShowOptions={setAutocompleteProductOptions}
            searchText={modelName}
            isDisabled={manufacturer === undefined}
            placeholder=""
            loadingSearch={loadingSearch}
            showErasedSearch={loadingSearch}
            searchOnChange={searchProductFunc}
            closeIconOnClick={() => {
              setModelName('');
              setModelNumber('');
              setModelName('');
            }}
            onClickFilter={item => {
              startProductSearch(item.labelOne);
              setModelName(item.labelOne);
              setOption(-1);
              setLoadingSearch(true);
              setAutocompleteProductOptions([]);
            }}
            option={option}
            setOption={setOption}
          />
        </InputDiv>
        {manufacturer && (
          <FindButton
            disabled={modelNumber.length === 0 && modelName.length === 0}
            onClick={() => startProductSearch()}
          >
            Find!
          </FindButton>
        )}
      </GlobalInputContainer>
      {data !== undefined && (data.total === 0 || data.total > LIMIT) && (
        <>
          <RowDiv style={{ marginTop: 24 }}>
            {data.total > LIMIT && (
              <WarningText>Too many results found.</WarningText>
            )}

            {data.total === 0 && (
              <WarningText style={{ color: '#ff5656' }}>
                Zero results found.
              </WarningText>
            )}
            <>
              <span>&nbsp;</span>
              <BoldText>Try improving the criteria above!!</BoldText>
            </>
          </RowDiv>

          <Description>
            If that’s not possible, you can skip the product match process for
            now, but you’ll be missing out on updates such as new firmware, end
            of life announcements, etc, as well as documents, tickets, and more!
            If that’s your choice, you’ll be able to continue this process in
            the equipment page.
          </Description>
        </>
      )}
      {manufacturerArray !== undefined && manufacturerArray.total === 0 && (
        <>
          <RowDiv style={{ marginTop: 24 }}>
            {manufacturerArray.total === 0 && (
              <WarningText style={{ color: '#ff5656' }}>
                Zero results found.
              </WarningText>
            )}
            <>
              <span>&nbsp;</span>
              <BoldText>Try improving the criteria above!!</BoldText>
            </>
          </RowDiv>

          <Description>
            If that’s not possible, you can skip the manufacturer match process
            for now, but you’ll be missing out on updates such as new firmware,
            end of life announcements, etc, as well as documents, tickets, and
            more! If that’s your choice, you’ll be able to continue this process
            in the equipment page..
          </Description>
        </>
      )}
      {manufacturer === undefined && (
        <ListManufacturersWithMatch
          data={manufacturerArray?.results}
          loadMore={() => loadMoreManufactures()}
          hasMore={data?.hasMore}
          isLoading={loadingSearch}
          updateDataSelected={input => {
            setManufacturer(input);
            setManufacturerArray(undefined);
            setTextManufacturer(input.name);
          }}
          handleClick={handleProductFocus}
        />
      )}
      {((manufacturer !== undefined &&
        data &&
        data.total < LIMIT &&
        data.total > 0) ||
        (loadingSearch && manufacturer)) && (
        <ListEquipmentsWithMatch
          data={data?.results}
          loadMore={() => loadMoreProducts()}
          hasMore={data?.hasMore}
          isLoading={loadingSearch}
          updateDataSelected={updateDataSelected}
          nextBody={nextBody}
        />
      )}
      {((data === undefined && manufacturerArray === undefined) ||
        (data && (data.total > LIMIT || data.total === 0)) ||
        (manufacturerArray && manufacturerArray.total === 0) ||
        loadingSearch) && <div style={{ display: 'flex', height: '100%' }} />}
      <Buttons>
        {!!manufacturer && modelName && (
          <Skip
            onClick={() => {
              updateDataSelected([
                {
                  id: `${manufacturer?.id}-${undefined}-${modelName}`,
                  isTempProduct: true,
                  tempProductName: modelName,
                  quantity: 1,
                  manufacturerId: manufacturer.id,
                },
              ]);
              nextBody();
              manualAddSkipProduct(studioName, modelName);
            }}
          >
            Skip Product Matching
          </Skip>
        )}
        {manufacturer && (
          <Cancel
            disabled={!manufacturer}
            onClick={() => {
              setData(undefined);
              setManufacturer(undefined);
              setModelNumber('');
              setManufacturerArray(undefined);
              setTextManufacturer('');
              setPage(1);
              setLoadingSearch(false);
              setModelName('');
              handleManufacturerFocus();
            }}
          >
            Clear
          </Cancel>
        )}

        <ReactTooltip className="tooltip" id="tooltipHeader" effect="solid" />
      </Buttons>
      <DeleteDialog
        open={openAlertDialog}
        buttonText={
          textManufacturer.length > 0 &&
          modelName.length === 0 &&
          modelNumber.length === 0
            ? `Skip with ${textManufacturer}`
            : modelName.length > 0 || modelNumber.length > 0
            ? `Skip with ${modelNumber.length > 0 ? modelNumber : ''}${
                modelNumber.length > 0 && modelName.length > 0 ? ' - ' : ''
              }${modelName.length > 0 ? modelName : ''}`
            : 'Skip'
        }
        cancelText={
          manufacturerArray && manufacturerArray.total > 0
            ? 'Select a Manufacturer'
            : data && data.total > 0
            ? 'Select a Product'
            : 'Cancel'
        }
        width={434}
        text={
          (manufacturerArray && manufacturerArray.total > 0) ||
          (data && data.total > 0)
            ? 'There were possible results from your criteria. Make sure it is not one of them first.'
            : (manufacturerArray && manufacturerArray.total === 0) ||
              (textManufacturer.length > 0 && !manufacturer)
            ? 'We’ll be notified of a new Manufacturer. Once validated, we’ll begin our Data Acquisition Pipeline'
            : textManufacturer.length > 0
            ? 'We’ll be notified of a new Product. Once validated, we’ll begin our Data Acquisition Pipeline'
            : 'Selecting a manufacturer will help narrow the results. Feel free to add it later if necessary'
        }
        onDelete={() => {
          if (textManufacturer.length === 0) {
            setManufacturer(Manufacturer.createEmptyManufacturer());
            setManufacturerArray(undefined);
          }
          if (!manufacturer) {
            setManufacturer(
              Manufacturer.createEmptyManufacturer(textManufacturer),
            );
            setManufacturerArray(undefined);
          }
          if (
            manufacturer &&
            manufacturer.id.length === 0 &&
            manufacturer.name.length > 0
          ) {
            mutationCreateManufacturer.mutate({
              data: {
                name: textManufacturer,
              },
            });
          }
          if (manufacturer) {
            mutationCreateProduct.mutate({
              data: {
                name: modelName.length > 0 ? modelName : undefined,
                model: modelNumber.length > 0 ? modelNumber : undefined,
                description: undefined,
                manufacturerId:
                  manufacturer.id.length === 0 ? undefined : manufacturer.id,
              },
            });
          }
          openAlertDialog.set(false);
        }}
      />
    </BodyFind>
  );
}; //
